import httpClient from '../httpClient';

export interface ChatbotConversation {
  uuid: string;
  title: string;
  status: 'active' | 'closed' | 'escalated';
  ticket_id: number | null;
  created_at: string;
  updated_at: string;
  last_message?: string;
}

export interface ChatbotMessage {
  id?: number;
  role: 'user' | 'assistant' | 'system';
  content: string;
  metadata?: {
    ticket?: { id: number; ticket_number: string };
  } | null;
  created_at: string;
}

export interface SendMessageResponse {
  message: ChatbotMessage;
  ticketCreated?: {
    id: number;
    ticket_number: string;
    subject: string;
  } | null;
}

export const createConversation = async (): Promise<ChatbotConversation> => {
  const response = await httpClient.post<{ success: boolean; data: ChatbotConversation }>(
    '/chatbot/conversations'
  );
  return response.data;
};

export const getConversations = async (): Promise<ChatbotConversation[]> => {
  const response = await httpClient.get<{ success: boolean; data: ChatbotConversation[] }>(
    '/chatbot/conversations'
  );
  return response.data;
};

export const getConversation = async (uuid: string): Promise<{ conversation: ChatbotConversation; messages: ChatbotMessage[] }> => {
  const response = await httpClient.get<{ success: boolean; data: { conversation: ChatbotConversation; messages: ChatbotMessage[] } }>(
    `/chatbot/conversations/${uuid}`
  );
  return response.data;
};

export const sendMessage = async (uuid: string, message: string): Promise<SendMessageResponse> => {
  const response = await httpClient.post<{ success: boolean; data: SendMessageResponse }>(
    `/chatbot/conversations/${uuid}/messages`,
    { message },
    { timeout: 60000 } as any
  );
  return response.data;
};

export const escalateToTicket = async (uuid: string, data: { subject: string; category: string; description?: string }): Promise<any> => {
  const response = await httpClient.post<{ success: boolean; data: any }>(
    `/chatbot/conversations/${uuid}/escalate`,
    data
  );
  return response.data;
};

export const closeConversation = async (uuid: string): Promise<void> => {
  await httpClient.patch(`/chatbot/conversations/${uuid}/close`);
};
